import { _ as __read } from '../../../_tslib-7a01aab4.js';

/**
 * @desc old name amountConverterPipe
 * @param value
 */
var convertAmount = function (value) {
    if (value || value === 0) {
        // Split the number into integer and decimal parts
        var _a = __read(value.toString().split('.'), 2), integerPart = _a[0], decimalPart = _a[1];
        // Format the integer part with commas
        var formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        // Join the formatted integer part and the original decimal part
        return decimalPart ? "".concat(formattedIntegerPart, ".").concat(decimalPart) : formattedIntegerPart;
        // OLD VERSION value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    else {
        // console.error(`NOT VALID VALUE - ${value}`);
        return '';
    }
};

export { convertAmount };
